<style scoped>
.main_text{
	width: 95%;
	margin: auto;
	text-align: left;
}
.hyper_link{
	text-decoration: underline;
}
</style>
<style src="@/assets/css/common.css" scoped></style>
<template>
	<div>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					Command Line Tool
				</div>
			</b-row>
			<b-row>
				<div class="main_text">
					To run NetFlow3D locally or access the source code, please visit NetFlow3D GitHub repository: <a href="https://github.com/haiyuan-yu-lab/NetFlow3D" class="hyper_link">https://github.com/haiyuan-yu-lab/NetFlow3D</a>.
				</div>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					Citation
				</div>
			</b-row>
			<b-row>
				<div class="main_text">
					To cite the NetFlow3D paper, please reference: <a href="https://www.nature.com/articles/s41467-024-54176-3" class="hyper_link">https://www.nature.com/articles/s41467-024-54176-3</a>.<br>
					If you find the supplementary and source data in the NetFlow3D paper helpful, kindly cite: <a href="https://doi.org/10.5281/zenodo.13755995" class="hyper_link">https://doi.org/10.5281/zenodo.13755995</a>.<br>
					If you find the NetFlow3D GitHub repository helpful, kindly cite: <a href="https://doi.org/10.5281/zenodo.13754812" class="hyper_link">https://doi.org/10.5281/zenodo.13754812</a>.
				</div>
			</b-row>
		</b-container>
		<br>
		<br>
		<b-container>
			<b-row>
				<div class="sec_header"> 
					Contact
				</div>
			</b-row>
			<b-row>
				<div class="main_text">
					This web server is maintained by Yu Lab at Cornell University. For contact information please visit <a href="https://yulab.org/" class="hyper_link">www.yulab.org</a>.
				</div>
			</b-row>
		</b-container>
	</div>
</template>

<script>

export default {
	components: {
	},
	data() {
		return {
			datacollection: null,
			lineDatacollection: null,
			options: null,
		};
	},
	created() {
		localStorage.clear();
		this.fillData();
		this.fillOption();
	},
	mounted() {},
	methods: {
		fillData() {
			this.datacollection = {
				labels: [this.getRandomInt(), this.getRandomInt()],
				datasets: [
					{
						label: "Data One",
						backgroundColor: "#f87979",
						data: [this.getRandomValues(100, 200), this.getRandomValues()],
					},
					{
						label: "Data Two",
						backgroundColor: "blue",
						data: [this.getRandomValues(), this.getRandomValues(20, 80)],
					},
				],
			};
			this.lineDatacollection = {
				labels: [
					"January",
					"February",
					"March",
					"April",
					"May",
					"June",
					"July",
				],
				datasets: [
					{
						label: "Data One",
						backgroundColor: "#f87979",
						data: [40, 39, 10, 40, 39, 80, 40],
					},
				],
			};
		},
		fillOption() {
			this.options = {
				responsive: true,
				maintainAspectRatio: false,
				onClick: this.handle,
				// onHover: this.handle
			};
		},
		handle(point, event) {
			const item = event[0];
			console.log(item);
		},
		getRandomInt() {
			return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
		},
		getRandomValues(min = 0, max = 100) {
			return Array.from({ length: 100 }).map(
				() => Math.random() * (max - min) + min
			);
		},
	},
};
</script>
